<style scoped lang="less">
@import url("../../static/style/index.less");
.boxBg {
  width: 100%;
  padding: 0.8em 0 0.9em;
  background: @colorBgBox;
  &_head {
    border-bottom: 1px solid @colorOne;
    padding-bottom: 0.15em;
    position: relative;
    &_h3 {
      font-size: 0.26em;
      color: @color3;
      margin: 0 0 0.08em;
    }
    &_Eng {
      font-size: 0.16em;
      color: @color9;
      font-weight: 500;
      margin-right: 0.625em;
      cursor: pointer;
      span {
        color: @colorOne;
        float: right;
        .display_alignItem;
        img {
          width: 0.7em;
          height: 0.7em;
          margin-left: 0.3em;
        }
      }
    }
    &_line {
      width: 0.85em;
      height: 4px;
      position: absolute;
      left: 0;
      bottom: -2px;
      background: @colorOne;
    }
  }
}
</style>
<template>
  <div class="boxBg_head">
    <div class="boxBg_head_h3">{{headObj.title}}</div>
    <div class="boxBg_head_Eng" @click="goToMore">
      {{headObj.titleEng}}
      <span>
        更多
        <img src="@/assets/image/index/moreB.png" alt />
      </span>
    </div>
    <div class="boxBg_head_line"></div>
  </div>
</template>
<script>
export default {
  props: {
    headObj: {
      type: Object,
      default: {},
    },
  },
  methods: {
    goToMore() {
      if (this.headObj.title == "云课堂") {
        this.$router.push({
          path: "/cloudClassroom",
        });
      }else if(this.headObj.title == "专员风采"){
         this.$router.push({
          path: "/savant",
        });
      }else if(this.headObj.title == "产品与服务"){
         this.$router.push({
          path: "/case",
        });
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/boxHead.vue